import { GroupedPlayersData, PlayerWithRisk } from '../dashboard.type';
import { DeadlineInfo } from '../../../hooks/useDashboardHarmReports.types';

export type ListLayoutProps = {
  playersData: GroupedPlayersData;
  onPlayerClick: (player: PlayerWithRisk) => void;
  deadlineMap: Map<string, DeadlineInfo>;
  currentMinute: number;
};

export enum HoverKey {
  HighDown = 'highDown',
  HighUp = 'highUp',
  LowDown = 'lowDown',
  LowUp = 'lowUp',
}

export type HoverState = Record<HoverKey, boolean>;
